import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';

interface TokenizeTextFieldProps {
  className?: string;
  label?: string;
  name: string;
  onChangeCallBack?: () => void;
  placeholder?: string;
}

export default function TokenizeTextField(props: TokenizeTextFieldProps) {
  const { className, label, name, onChangeCallBack, placeholder } = props;
  const [field, meta, helpers] = useField(props);
  const [inputValue, setInputValue] = useState<string>('');

  const handleChange = (value) => {
    helpers.setValue(
      value || {
        label: '',
        value: '',
      }
    );
    setInputValue('');
  };

  // optional callback to trigger after field gets change.
  useEffect(() => {
    if (onChangeCallBack) {
      onChangeCallBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value]);

  const onBlur = (e) => {
    if (e.currentTarget.value) {
      handleChange(uniqValidation(e.currentTarget.value));
    }
    helpers.setTouched(true);
  };

  const onKeyDown = (e) => {
    if (e.type === 'keydown' && (e.code === 'Space' || e.code === 'Comma')) {
      e.preventDefault();
      if (inputValue) {
        handleChange(uniqValidation(e.target.value));
        e.target.value = '';
      }
    }
  };

  const uniqValidation = (value: string) => {
    const fieldValues = [...field.value, { label: value, value: value }];
    return [...new Map(fieldValues.map((item) => [item.value.replace(/\s/g, ''), item])).values()];
  };

  return (
    <div className={`TokenizeTextField form-group ${className || ''}`}>
      {label && (
        <label className="input-label" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="forum-group-content">
        <div className="input-container">
          <AsyncSelect
            className={meta.touched && meta.error ? 'is-invalid' : ''}
            classNamePrefix="react-select"
            onChange={(value) => helpers.setValue(value)}
            onInputChange={setInputValue}
            inputValue={inputValue}
            onBlur={onBlur}
            isClearable
            isMulti={true}
            value={field.value}
            onKeyDown={onKeyDown}
            placeholder={placeholder || ''}
            inputId={name}
            {...props}
          />
        </div>
      </div>
      {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  );
}
